<mat-form-field appearance="fill">
  <mat-label>{{ texts.report.year | translate }}</mat-label>
  <input
    matInput
    [matDatepicker]="dp"
    (keydown.arrowDown)="previousYear($event)"
    (keydown.arrowUp)="nextYear($event)"
    [formControl]="date"
    (dateChange)="onChange()"
  />

  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event, dp)"
    panelClass="example-month-picker"
  >
  </mat-datepicker>
</mat-form-field>
